import { useEffect } from 'react';

const useCardGlow = () => {
  useEffect(() => {
    const handleMouseMove = (e) => {
      const cards = document.querySelectorAll('[data-glow]');
      
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Check if mouse is within card bounds
        const isInside = x >= 0 && x <= rect.width && y >= 0 && y <= rect.height;
        
        if (isInside) {
          // Calculate ratios (0 to 1)
          const ratioX = x / rect.width;
          const ratioY = y / rect.height;
          
          // Calculate 3D tilt (centered from -1 to 1)
          const tiltX = (ratioY - 0.5) * 2; // -1 to 1
          const tiltY = (ratioX - 0.5) * 2; // -1 to 1
          
          // Set CSS custom properties on each card
          card.style.setProperty('--ratio-x', ratioX);
          card.style.setProperty('--ratio-y', ratioY);
          card.style.setProperty('--tilt-x', `${tiltX * -15}deg`); // Max 15deg rotation
          card.style.setProperty('--tilt-y', `${tiltY * 15}deg`);  // Max 15deg rotation
        } else {
          // Reset tilt when mouse is outside
          card.style.setProperty('--tilt-x', '0deg');
          card.style.setProperty('--tilt-y', '0deg');
        }
      });
    };

    // Listen for mouse movement on the entire document
    document.addEventListener('pointermove', handleMouseMove);

    return () => {
      document.removeEventListener('pointermove', handleMouseMove);
    };
  }, []);
};

export default useCardGlow;